
const routes = [

  {
    path: '/registro',
    name: 'registro',
    component: () => import(/* webpackChunkName: "empresa" */ '@/views/Registro/RegistroSistema.vue')
  },
  {
    path: '/registrovisual',
    name: 'registrovisual',
    component: () => import(/* webpackChunkName: "empresa" */ '@/views/Registro/RegistroVisualSistema.vue'),    
  },
  {
    path: '/registrofirmamanuscrita',
    name: 'registrofirmamanuscrita',
    component: () => import(/* webpackChunkName: "empresa" */ '@/views/Registro/CargarFirmaManuscritaSistema.vue'),    
  },
  
];

export default routes.map(route => {
  return { ...route, meta: { public: false, admin:false, adminSagrilaft:false, adminCumplimiento:false, tercero:true } }
})